<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-inexorange hover:text-white" :href="route('users')">Usuario</inertia-link>
        <span class="text-white font-medium">/ {{ form.first_name }}</span>
        
      </h1>
      <img v-if="user.photo" class="block w-8 h-8 rounded-full ml-4" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
      El usuario Fue Eliminado !
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-3/6" label="Nombres" required/>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-3/6" label="Email" required/>
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-3/6" type="password" autocomplete="new-password" label="Password" />
          <select-input v-if="$page.props.auth.user.rol == 'Admin'" v-model="form.rol" :error="form.errors.rol" class="pr-6 pb-8 w-full lg:w-3/6" label="Rol" required>
            <option>Admin</option>
            <option>Gerente</option>
            <option>Comercio</option>
          </select-input>
            <select-input v-if="$page.props.auth.user.rol == 'Admin'" v-model="form.organization_id" :error="form.errors.forma_pago" class="pr-6 pb-8 w-full lg:w-3/6 border-inexgray focus:border-inexorange" label="Comercio">
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.nameCommerce }} </option>
          </select-input>  
         </div>
        <div class="px-8 py-4 bg-transparent flex items-center">
          <button v-if="!user.deleted_at && $page.props.auth.user.rol =='Admin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">BORRAR USUARIO</button>
          <loading-button  :loading="form.processing" style="color: white;" class="px-8 py-4 btn-indigoOrange ml-auto" type="submit">ACTUALIZAR USUARIO</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        organization_id: this.user.organization_id,
        last_name: this.user.last_name,
        email: this.user.email,
        password: null,
        rol: this.user.role,
        photo: null,
        tipo: this.user.tipo,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('users.update', this.user.id), {
        onSuccess: () => this.form.reset('password'),
      })
    },
    destroy() {
      if (confirm('Está seguro de Eliminar este Usuario?')) {
        this.$inertia.delete(this.route('users.destroy', this.user.id))
      }
    },
    editusuario() {
      if (confirm('Quiere Editar Datos de Cliente?')) {
        this.$inertia.get(this.route('contacts.edit', this.user.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar este Usuario?')) {
        this.$inertia.put(this.route('users.restore', this.user.id))
      }
    },
  },
}
</script>
